enum WebRoutes {
  HOME = '/',
  CLIENT_EDIT = '/client/edit',
  CLIENT_EDIT_QUERRY_CLIENT_ID = '/client/edit?clientId=',
  CREATE_CLIENT = '/client/create',
}

export default WebRoutes;
